import React from 'react';

const UserAvatar = ({ user, size = 40, className = '', fontSize, showUid = false }) => {
    if (!user) {
        return <div className={`rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center fw-bold shadow-sm ${className}`} style={{ width: size, height: size, fontSize: fontSize || size * 0.35 }}>?</div>;
    }

    const getInitials = (u) => {
        return `${u.first_name?.[0] || ''}${u.last_name?.[0] || ''}`.toUpperCase();
    };

    const getRandomColor = (id) => {
        // Safe Bootstrap colors that work well with text-white
        const colors = [
            'bg-primary',
            'bg-success',
            'bg-danger',
            'bg-dark',
            'bg-secondary',
            'bg-info' // Note: bg-info text might usually be black, but we force text-white so it should be readable on dark teal/cyan
        ];

        let hash = 0;
        const strId = String(id || '');
        for (let i = 0; i < strId.length; i++) {
            hash = strId.charCodeAt(i) + ((hash << 5) - hash);
        }

        const index = Math.abs(hash) % colors.length;
        return colors[index];
    };

    return (
        <div className={`d-flex align-items-center ${className}`}>
            <div className="position-relative">
                {user.avatar_url ? (
                    <img
                        src={user.avatar_url}
                        alt={`${user.first_name}`}
                        className="rounded-circle shadow-sm object-fit-cover"
                        style={{ width: size, height: size }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                ) : null}
                <div
                    className={`rounded-circle ${getRandomColor(user.id)} text-white align-items-center justify-content-center fw-bold shadow-sm`}
                    style={{
                        width: size,
                        height: size,
                        fontSize: fontSize || size * 0.35,
                        display: user.avatar_url ? 'none' : 'flex'
                    }}
                >
                    {getInitials(user)}
                </div>
            </div>
            {showUid && (
                <div className="ms-3">
                    <div className="fw-bold text-dark">{user.first_name} {user.last_name}</div>
                    <div className="text-muted small">UID: {user.id}</div>
                </div>
            )}
        </div>
    );
};

export default UserAvatar;
